import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import OrderStaticTableCell from './OrderStaticTableCell';

const forecastBodyColors = {
  OA: 'transparent',
  HM: 'transparent',
  ES: 'transparent',
};

const OrderStaticsTeamRows = ({ headerRows, data, selectPrjTyp, useKorean }) => {
  if (!headerRows || !data) return null;

  return data.map((hq, hqIndex) => {
    return hq?.children.map((dp, dpIndex) => {
      const isTotalRow = dp.id === 'total' || dp.id === 'one';
      const subtotalBgColor = isTotalRow ? (dp.id === 'one' ? '#f5f5f5' : '#edf2f7') : 'inherit';
      const bottomBorder = isTotalRow ? '2px solid #dadce0' : '1px solid #f1f3f4';

      return (
        <TableRow 
          key={`${hqIndex}-${dpIndex}`}
          sx={{ 
            backgroundColor: subtotalBgColor,
            '& .MuiTableCell-root': { borderBottom: bottomBorder },
          }}
        >
          {/* 본부 컬럼 */}
          {dpIndex === 0 && dp.id !== 'total' && (
            <TableCell 
              rowSpan={hq.rowSpan} 
              sx={{ 
                width: useKorean ? '90px !important' : 'max-content',
                minWidth: useKorean ? '90px !important' : '90px',
                bgcolor: '#f5f5f5', 
                fontWeight: 'bold',
                borderRight: '1px solid #eee',
              }} 
              align={'center'}
            > 
              {hq.name}
            </TableCell>
          )}

          {/* 팀 컬럼 */}
          <TableCell
            sx={{ 
              width: selectPrjTyp === 'A' ? '70px !important' : 'max-content',
              minWidth: selectPrjTyp === 'A' ? '90px !important' : '100px',
              bgcolor: isTotalRow ? (dp.id === 'one' ? '#f5f5f5' : '#edf2f7') : '#ffffff',
              fontWeight: isTotalRow ? 600 : 400,
              color: isTotalRow ? '#000' : 'inherit',
              borderRight: '1px solid #eee',
            }}
            align={dp.id === 'total' ? 'center' : dp.id === 'one' ? 'right' : 'center'}
            colSpan={dp.id === 'total' ? 2 : 1}
          >
            {dp.name}
          </TableCell>

          {/* 데이터 셀 */}
          <OrderStaticTableCell 
            useKorean={useKorean}
            selectPrjTyp={selectPrjTyp} 
            headerRows={headerRows} 
            data={dp} 
            bodyColors={forecastBodyColors} 
            isTotalRow={isTotalRow}
          />
        </TableRow>
      );
    });
  });
};

export default OrderStaticsTeamRows;
